// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CartShopping: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 29 29"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fillRule="nonzero"
                d="M4.044 2c.377 0 .705.261.788.63l.222.987h22.33c1.027 0 1.846 1.024 1.558 2.056l-2.73 9.706a1.618 1.618 0 01-1.557 1.178H7.996l.738 3.235H25.07c.445 0 .809.363.809.808a.811.811 0 01-.81.809H8.088a.81.81 0 01-.788-.632l-3.9-17.16H.808A.809.809 0 11.809 2h3.235zm1.38 3.235l2.163 9.704h17.068l2.73-9.704H5.423zM6.47 25.048a2.832 2.832 0 012.83-2.83c1.562 0 2.83 1.268 2.83 2.83s-1.268 2.83-2.83 2.83-2.83-1.268-2.83-2.83zm2.83 1.213c.672 0 1.213-.54 1.213-1.213s-.54-1.213-1.213-1.213-1.213.54-1.213 1.213.54 1.213 1.213 1.213zm16.579-1.213c0 1.562-1.269 2.83-2.83 2.83s-2.831-1.268-2.831-2.83 1.268-2.83 2.83-2.83 2.83 1.268 2.83 2.83zm-2.83-1.213c-.673 0-1.214.54-1.214 1.213s.54 1.213 1.213 1.213 1.213-.54 1.213-1.213-.54-1.213-1.213-1.213z"
            />
        </svg>
    );
};

export default React.memo(CartShopping);
